// Module
var code = `<div class="quickTableOuter {{.additionalClass}}"
     {{^.enabled}}disabled="" {{/}}
     {{#if .autocompleteTable}}
     style="outline:none;{{#.zIndex}}z-index:{{.zIndex}};{{/}}{{>position}}"
     {{else}}
     style="{{>visibility}}"
     {{/if}}>

    <canvas id="{{.id}}"
            style="background-color:{{.tableBackColor}};cursor:{{.currentCursor}}; width: {{.width}}px; height: {{.height}}px;"
            on-mousedown="@this.onMouseDown(event)"
            on-mousemove="@this.onMouseMove(event)"
            on-mouseleave="@this.onMouseLeave(event)"
            on-mouseup="@this.onMouseUp(event)"
            on-wheel="@this.onMouseWheel(event)"
            on-mousewheel="@this.onMouseWheel(event)"
            on-click="@this.onClick(event)"
            on-contextmenu="@this.onContextMenu(event)"
            on-dblclick="@this.onDoubleClick(event)">
    </canvas>
</div>`;
// Exports
export default code;